import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// --- RESİMLER ---
import heroImg from './images/hero-saha.png';
import ardaImg from './images/arda.jpg';
import asensioImg from './images/asensio.jpg';
import barisImg from './images/baris.jpg';
import ferdiImg from './images/ferdi.jpg';
import hakanImg from './images/hakan.jpg';
import kenanImg from './images/kenan.jpg';
import messiImg from './images/messi.jpg';
import milliImg from './images/milli.jpg';
import neymarImg from './images/neymar.jpg';
import ronaldoImg from './images/ronaldo.jpg';

const galleryImages = [
  ronaldoImg, ardaImg, messiImg, kenanImg, neymarImg,
  barisImg, asensioImg, ferdiImg, milliImg, hakanImg
];


const styles = {
  container: {
    fontFamily: "'Segoe UI', sans-serif",
    minHeight: '100vh',
    background: 'linear-gradient(to right, #ffffff, #f0f2f5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#333',
    overflowX: 'hidden'
  },
  heroSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '85%',
    maxWidth: '1400px',
    padding: '40px',
    flexWrap: 'wrap-reverse',
    gap: '60px'
  },
  heroContent: { flex: 1, minWidth: '320px', zIndex: 2 },
  badge: {
    background: '#e3f2fd',
    color: '#3498db',
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: 'bold',
    letterSpacing: '1px'
  },
  heroTitle: { fontSize: '64px', fontWeight: '900', lineHeight: '1.1', color: '#2c3e50', margin: '25px 0' },
  heroText: { fontSize: '20px', color: '#7f8c8d', marginBottom: '40px', lineHeight: '1.6', maxWidth: '500px' },
  heroButtons: { display: 'flex', gap: '20px' },
  primaryBtn: { padding: '18px 35px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 10px 25px rgba(231, 76, 60, 0.3)', transition: '0.3s' },
  secondaryBtn: { padding: '18px 35px', background: 'white', color: '#2c3e50', border: '2px solid #eee', borderRadius: '12px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', transition: '0.3s' },
  miniStats: { display: 'flex', gap: '30px', marginTop: '40px', fontSize: '14px', color: '#95a5a6' },
  heroImageContainer: {
    flex: 1,
    minWidth: '320px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    perspective: '1000px',
  },
  heroImage: {
    width: '100%',
    maxWidth: '550px',
    height: '600px',
    borderRadius: '30px',
    transform: 'rotateY(-10deg) rotateX(5deg)',
    zIndex: 2,
    boxShadow: '0 20px 50px rgba(0,0,0,0.2)',
    objectFit: 'cover',
    objectPosition: 'top center',
    border: '5px solid white',
  },
  imageDecor: {
    position: 'absolute',
    top: '-20px',
    right: '20px',
    width: '90%',
    height: '100%',
    background: '#2ecc71',
    borderRadius: '30px',
    transform: 'rotate(5deg)',
    zIndex: 1,
    opacity: 0.2
  },
  dotsContainer: {
    position: 'absolute',
    bottom: '-40px',
    display: 'flex',
    gap: '8px'
  },
  dot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    transition: 'all 0.3s'
  }
};

const Home = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) return;
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [isMobile]);


  const dynamicStyles = {
    heroSection: {
      ...styles.heroSection,
      width: isMobile ? '100%' : '85%',
      padding: isMobile ? '20px' : '40px',
      flexDirection: isMobile ? 'column' : 'row',
      textAlign: isMobile ? 'center' : 'left',
      gap: isMobile ? '30px' : '60px'
    },
    heroContent: {
      ...styles.heroContent,
      minWidth: isMobile ? '100%' : '320px',
    },
    heroTitle: {
      ...styles.heroTitle,
      fontSize: isMobile ? '32px' : '64px',
      textAlign: isMobile ? 'center' : 'left',
      margin: isMobile ? '15px 0' : '25px 0'
    },
    heroText: {
      ...styles.heroText,
      fontSize: isMobile ? '16px' : '20px',
      maxWidth: isMobile ? '100%' : '500px',
      textAlign: isMobile ? 'center' : 'left',
      margin: isMobile ? '0 auto 25px auto' : '0 0 40px 0'
    },
    heroButtons: {
      ...styles.heroButtons,
      justifyContent: isMobile ? 'center' : 'flex-start',
      flexWrap: 'wrap',
      gap: '12px'
    },
    heroImageContainer: {
      ...styles.heroImageContainer,
      minWidth: isMobile ? '100%' : '320px',
    },
    heroImage: {
      ...styles.heroImage,
      height: isMobile ? '400px' : '600px',
      width: isMobile ? '100%' : '100%',
      maxWidth: isMobile ? '350px' : '550px',
      objectFit: 'cover',
      objectPosition: 'top center',
      transform: isMobile ? 'rotateY(-5deg) rotateX(5deg)' : 'rotateY(-10deg) rotateX(5deg)',
      margin: isMobile ? '0 auto' : '0'
    },
    imageDecor: {
      ...styles.imageDecor,
      display: isMobile ? 'none' : 'block'
    }
  };

  return (
    <div style={styles.container}>
      <header style={dynamicStyles.heroSection}>
        <div style={dynamicStyles.heroContent}>
          <span style={styles.badge}>MAÇ HEYECANI BAŞLASIN ⚽</span>
          <h1 style={dynamicStyles.heroTitle}>
            Sahaların Yıldızı <br />
            <span style={{ color: '#2ecc71' }}>Sen Ol!</span>
          </h1>
          <p style={dynamicStyles.heroText}>
            sahalive ile maçlarını profesyonelce kaydet, gollerini izle ve paylaş.
            Artık başrol sensin.
          </p>

          <div style={dynamicStyles.heroButtons}>
            <Link to="/live">
              <button style={styles.primaryBtn}>
                 Canlı İzle
              </button>
            </Link>
            <Link to="/archives">
              <button style={styles.secondaryBtn}>
                 Geçmiş Özet
              </button>
            </Link>
          </div>

          <div style={{ ...styles.miniStats, justifyContent: isMobile ? 'center' : 'flex-start', gap: isMobile ? '15px' : '30px' }}>
            <div>⭐ <b>5.000+</b> Oyuncu</div>
            <div>️ <b>45+</b> Saha</div>
          </div>
        </div>

        <div style={dynamicStyles.heroImageContainer}>
          <img
            src={isMobile ? heroImg : galleryImages[currentImageIndex]}
            alt="Futbol Yıldızı"
            style={dynamicStyles.heroImage}
            key={isMobile ? 'hero' : currentImageIndex}
          />
          <div style={dynamicStyles.imageDecor}></div>

          {!isMobile && (
            <div style={styles.dotsContainer}>
              {galleryImages.map((_, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.dot,
                    background: index === currentImageIndex ? '#2ecc71' : '#ccc',
                    transform: index === currentImageIndex ? 'scale(1.3)' : 'scale(1)'
                  }}
                ></div>
              ))}
            </div>
          )}

        </div>
      </header>
    </div>
  );
};

export default Home;